import { render, staticRenderFns } from "./listSubcategory.vue?vue&type=template&id=624d39a0"
import script from "./listSubcategory.vue?vue&type=script&lang=js"
export * from "./listSubcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports